import React from "react";
import PropTypes from "prop-types";
import "./App.css";
import { Switch } from "react-router-dom";
import Home from "./Home";
import SecurityQuestion from "./Login/SecurityQuestion";
import ImagePortal from "./ImagePortal/ImagePortal";
import Image from "./ImagePortal/Image";
import Container from "@material-ui/core/Container";
import NavBar from "./NavBar";
import NavDrawer from "./NavDrawer";
import PrivateRoute from "./PrivateRoute";
import ScrollToTop from "./ScrollToTop";

class Routes extends React.Component {
  render() {
    console.log("[ROUTE] RENDER", this.props.user.uid);
    const navDrawer = bool => {
      if (bool) {
        return <NavDrawer user={this.props.user} />;
      }
    };
    return (
      <div>
        <Container
          maxWidth={false}
          style={{
            background: "#F0f0f0",
            padding: "0 0px",
            overflow: "hidden",
            width: "100vw"
          }}
        >
          {navDrawer(this.props.auth !== "0" && this.props.auth !== "init")}
          <div style={{ marginLeft: "250px" }}>
            <NavBar />
            <div
              style={{
                height: "calc(100vh - 64px)",
                marginTop: "64px",
                overflowY: "auto"
              }}
            >
              <ScrollToTop>
                <Switch>
                  <PrivateRoute
                    path="/security-question"
                    component={SecurityQuestion}
                    auth={this.props.auth}
                  />
                  <PrivateRoute
                    path="/image/:imageName"
                    component={Image}
                    auth={this.props.auth}
                  />
                  <PrivateRoute
                    path="/image-portal"
                    component={ImagePortal}
                    auth={this.props.auth}
                  />
                  <PrivateRoute
                    path="/home"
                    component={Home}
                    auth={this.props.auth}
                  />
                  <PrivateRoute
                    path="/"
                    component={Home}
                    auth={this.props.auth}
                  />
                </Switch>
              </ScrollToTop>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

Routes.propTypes = {
  user: PropTypes.object,
  auth: PropTypes.object
};

export default Routes;
